import { create } from 'zustand';

export enum LoginState {
  Pending,
  In,
  Out,
}

type LoginStore = {
  iframeLoaded: boolean;
  popupVisible: boolean;
  closePopup: () => void;
  showPopup: () => void;
  token: string;
  setToken: (token: string) => void;
  loginState: LoginState;
  setLoginState: (state: LoginState) => void;
};

const initialState = {
  iframeLoaded: false,
  popupVisible: false,
  token: '',
  loginState: LoginState.Pending,
};

export const useLoginStore = create<LoginStore>()((set, get) => {
  return {
    ...initialState,
    showPopup: () => {
      set({
        popupVisible: true,
      });
    },
    closePopup: () => {
      set({
        popupVisible: false,
      });
    },
    setToken: (token) => {
      set({
        token,
      });
    },
    setLoginState: (loginState) => {
      set({
        loginState,
      });
    },
  };
});
